<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4.66663" y="5.71423" width="1.16667" height="6.85714" fill="#080828"/>
<rect x="8.16663" y="5.71423" width="1.16667" height="6.85714" fill="#080828"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.42862V2.28577H14V3.42862H12.8333V14.8572C12.8333 15.4884 12.311 16.0001 11.6667 16.0001H2.33333C1.689 16.0001 1.16667 15.4884 1.16667 14.8572V3.42862H0ZM2.33333 3.42862V14.8572H11.6667V3.42862H2.33333Z" fill="#080828"/>
<rect x="4.66663" width="4.66667" height="1.14286" fill="#080828"/>
</svg>
